import Chip from '@mui/material/Chip'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded'
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded'
import { useTranslation } from 'react-i18next'
import { getStatusColor, STATUS_LABEL_KEYS } from './complianceStatus'

const ICONS = {
  complete: CheckCircleRoundedIcon,
  pending: ScheduleRoundedIcon,
  expired: ErrorRoundedIcon
}

export default function ComplianceStatusChip({ status, size = 'small' }) {
  const { t } = useTranslation()
  const Icon = ICONS[status] || ScheduleRoundedIcon
  const color = getStatusColor(status)
  const label = t(STATUS_LABEL_KEYS[status] || STATUS_LABEL_KEYS.pending)

  return (
    <Chip
      size={size}
      icon={<Icon style={{ color: '#fff' }} fontSize='small' />}
      label={label}
      sx={{
        bgcolor: color,
        color: '#fff',
        fontWeight: 600,
        '& .MuiChip-icon': { color: '#fff' }
      }}
    />
  )
}
